import { FC, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import MemberSearch from "../../components/homepage/member/Search";
import MemberTable from "../../components/homepage/member/Table";
import SimpleHeader from "../../components/layout/SimpleHeader";
import styled from 'styled-components';
import qs from 'qs';
import ExtendButton from "../../components/ExtendButton";
import MemberInfoEditor from "../../components/homepage/member/Editor";
import { getMember, getMemberChildren } from "../../api/members.api";
import { useLocation } from "react-router-dom";
import useAxios from "../../hooks/useAxios";
import { IGetMember, IGetMemberChildren } from "../../models/members.model";
import MemberChildrenInfo from "../../components/homepage/member/ChildInfo";
import Loader from "../../components/Loader";
import ErrorResponse from "../../components/ErrorResponse";
import Split from "react-split";


const Block = styled.div`
  .close-left {
    transform: translate(-41.5%);
  }

`;

const HomepageMember: FC = () => {
  const { t } = useTranslation();
  const location = useLocation();

  const {
    data: member,
    isLoading: memeberIsLoading,
    error: memberError,
    execute: memberExecute
  } = useAxios<IGetMember>();

  const {
    data: memberChildren,
    isLoading: memberChildrenIsLoading,
    error: memberChildrenError,
    execute: memberChildrenExecute
  } = useAxios<IGetMemberChildren>();

  const [isExtended, setIsExtended] = useState(false);
  const [isMemberEdit, setIsMemberEdit] = useState(false);
  const [memberCode, setMemberCode] = useState('');
  const [memberType, setMemberType] = useState('');
  const query = qs.parse(location.search, { ignoreQueryPrefix: true });

  const onMemberEditClick = () => setIsMemberEdit(!isMemberEdit);

  useEffect(() => {
    if (memberCode) {
      memberExecute(getMember(memberCode));
      setIsMemberEdit(false);
      if (memberType) {
        memberChildrenExecute(getMemberChildren(memberCode));
      };
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps    
  }, [memberCode, memberType]);

  useEffect(() => {
    // console.log(query);
    if (query.memberCode) {
      setMemberCode(query.memberCode as string);
    }
    if (query.memberType) {
      setMemberType(query.memberType as string);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps    
  }, [location]);

  return (
    <>
    <SimpleHeader
      iconFile="icon-homepage-big.svg"
      parentMenu={t('common.menu.homepage')}
      currentMenu={t('homepage.member.37')}
      onlyTitle={true}
    />
    <div className="common-search">
      <div className="search-area">
        <MemberSearch />
      </div>
    </div>
    <Block className="content">
      {(memberChildrenIsLoading || memeberIsLoading) && <Loader />}
      <ErrorResponse error={memberError} />
      <ErrorResponse error={memberChildrenError} />

      <Split 
        className='splite-divide'
        sizes={[37, 63]}
        minSize={100}
        expandToMin={false}
        gutterSize={10}
        gutterAlign="center"
        snapOffset={30}
        dragInterval={1}
        direction="horizontal"
        cursor="col-resize"
      >
        <div className="col-frame left_panel">
          <MemberTable
            memberCode={memberCode}
          />
        </div>

        <div className="col-frame right_panel">
          <MemberInfoEditor
            member={member?.data}
            isEdit={isMemberEdit}
            onEditClick={onMemberEditClick}
            memberExecute={memberExecute}
          />
          <MemberChildrenInfo
            memberChildrenInfo={memberChildren?.data}
            member={member?.data}
          />
        </div>

      </Split>
    </Block>
    </>
  )
};

export default HomepageMember;